// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Usuarios_ToggleGrupoUsuarioInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /usuarios/toggleGrupoUsuario
 *
 * Toggles a group membership for a user.
 */
import { registerContract } from './validate'

export interface Usuarios_ToggleGrupoUsuarioInput {
username: string
grupo: string
}

registerContract('Usuarios_ToggleGrupoUsuarioInput', {
  username: { type: 'string',  required: true },
  grupo:    { type: 'string',  required: true },
})
